import React from "react";
import { Badge, Tooltip } from "antd";
import { useIntl } from "react-intl";

const OrderHours = (props) => {
  const { record } = props;
  const intl = useIntl();
  let total = 0;
  record.recurrent_work_events.forEach((item, i) => {
    total = Math.round((total + item.duration_minutes / 60) * 100) / 100;
  });
  let required_hours =
    Math.round((record.required_weekly_minutes / 60) * 100) / 100;
  const bg =
    total === required_hours ||
    (total > required_hours && record.service_type === 3)
      ? "#52c41a"
      : total > required_hours
      ? "#ff4d4f"
      : "#faad14";

  return (
    <Tooltip
      title={intl.formatMessage({
        id: "app.orders.hoursDescription",
      })}
      key={"info"}
    >
      <Badge
        count={`${total}/${required_hours}`}
        style={{ backgroundColor: bg }}
      />
    </Tooltip>
  );
};

export default OrderHours;
